import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as MaskData from "../Data/MaskData";
import { Paintable } from "../GameObjects/Paintable";
import { PaintableLayer } from "../GameObjects/PaintableLayer";

export class PaintableMask extends Paintable {
    private static readonly MAX_WIDTH: number = 600;

    private _outline: PIXI.Sprite;

    constructor(pIndex: number, pCreateInput: boolean = true) {
        super(pIndex);

        const sheet: string = Constants.SPRITESHEET_MASK_PREFIX + HLF.NumberUtils.addZeroPadding(this._index, 2);

        for (let i = 0; i < MaskData.LAYER_DATA[this._index].length; ++i) {
            const index: number = i;
            const layer: PaintableLayer = new PaintableLayer(
                "mask0" + this._index + "-" + HLF.NumberUtils.addZeroPadding(i, 2),
                sheet,
                // TODO:SH: Look into an alternative to baking in the index like this
                // maybe pass `this` and get index from array?
                () => { this.onLayerPainted(index); },
                pCreateInput ? MaskData.HIT_AREAS[this._index] : undefined,
                pCreateInput ? i : undefined,
            );
            layer.paint(MaskData.LAYER_DATA[this._index][i], 0, 0, true, true, true);
            layer.scale.set(4);
            this._layers.push(layer);
            this.addChild(layer);
        }

        this._outline = HLF.PixiUtils.makeSprite("mask0" + this._index + "-" + "outline", sheet);
        this.addChild(this._outline);

        const widthPerc: number = this._layers[0].width / PaintableMask.MAX_WIDTH;
        if (widthPerc > 1) {
            for (let i = 0; i < this._layers.length; ++i) {
                this._layers[i].scale.set(4 * (1 / widthPerc));
            }
            this._outline.scale.set(1 / widthPerc);
        }
    }
}
